export default {"src":"/_next/static/media/LMT.1d1bc77c.svg","height":18,"width":18};